"use client"

import { useState, useEffect } from "react"

export default function PaymentMethodModal({
  show,
  onClose,
  planKey,
  billingType,
  lowestAmount: initialAmount
}) {
  const [currency, setCurrency] = useState("USD")
  const [lowestAmount, setLowestAmount] = useState(initialAmount)

  useEffect(() => {
    if (currency === "USD") {
      const NGN_TO_USD = 0.0006666 // display only
      setLowestAmount(
        Math.round(initialAmount * NGN_TO_USD * 100) / 100
      )
    } else {
      setLowestAmount(initialAmount)
    }
  }, [currency, initialAmount])

  if (!show) return null

  const handleStripe = () => {
    window.dispatchEvent(
      new CustomEvent("startPayment", {
        detail: {
          method: "stripe",
          planKey,
          billingType,
          currency: "USD"
        }
      })
    )
    onClose()
  }

  const handlePaystack = () => {
    window.dispatchEvent(
      new CustomEvent("startPayment", {
        detail: {
          method: "paystack",
          planKey,
          billingType,
          currency: "NGN"
        }
      })
    )
    onClose()
  }

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <h4 style={titleStyle}>Choose Payment Method</h4>

        {/* Currency */}
        <div className="mb-4 text-start">
          <label className="form-label fw-medium" style={{ fontSize: "0.9rem" }}>
            Currency
          </label>
          <select
            className="form-select"
            value={currency}
            onChange={(e) => setCurrency(e.target.value)}
          >
            <option value="USD">USD ($)</option>
            <option value="NGN">NGN (₦)</option>
          </select>
        </div>

        {/* Amount */}
        <p style={{ marginBottom: "1.5rem" }}>
          Payable amount:{" "}
          <strong>
            {currency === "USD" ? "$" : "₦"}
            {lowestAmount}
          </strong>
        </p>

        {/* Stripe */}
        {currency === "USD" && (
          <button style={stripeBtn} onClick={handleStripe}>
            Continue with Stripe
          </button>
        )}

        {/* Paystack */}
        {currency === "NGN" && (
          <button style={paystackBtn} onClick={handlePaystack}>
            Continue with Paystack
          </button>
        )}

        <button className="btn btn-link text-muted mt-2" onClick={onClose}>
          Cancel
        </button>
      </div>
    </div>
  )
}

/* styles */
const overlayStyle = {
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0,0,0,0.6)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999
}

const modalStyle = {
  background: "#fff",
  borderRadius: "16px",
  width: "360px",
  padding: "2rem",
  textAlign: "center"
}

const titleStyle = {
  fontWeight: 700,
  marginBottom: "1.5rem"
}

const stripeBtn = {
  width: "100%",
  marginBottom: "0.75rem",
  background: "#635BFF",
  color: "#fff",
  padding: "0.75rem",
  borderRadius: "10px",
  border: "none",
  fontWeight: 600
}

const paystackBtn = {
  width: "100%",
  marginBottom: "0.75rem",
  background: "#0BA4DB",
  color: "#fff",
  padding: "0.75rem",
  borderRadius: "10px",
  border: "none",
  fontWeight: 600
}
